module.exports = __webpack_public_path__ + "img/gift.5332cbfb.jpg";